import { render, staticRenderFns } from "./FormTindakanEdit.vue?vue&type=template&id=569b6391&"
import script from "./FormTindakanEdit.vue?vue&type=script&lang=js&"
export * from "./FormTindakanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports